// extracted by mini-css-extract-plugin
export default {"container":"MenuCategory_container__4R3gr","footer":"MenuCategory_footer__tp-fO","buttonCounter":"MenuCategory_buttonCounter__D8R3D","center":"MenuCategory_center__RygKi"};